import React from "react"
import Table from "../../../components/common/Table"
import MaterialTable from "material-ui/Table"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import FontIcon from "material-ui/FontIcon"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import PayrollExpensesByHierarchyEmployeeRow from "./PayrollExpensesByHierarchyEmployeeRow"
import PayrollByHierarchyTableLockedColumn from "../../../components/payroll/PayrollByHierarchyTableLockedColumn"
import PayrollByHierarchyTableClosedColumn from "../../../components/payroll/PayrollByHierarchyTableClosedColumn"
import { green500 } from "material-ui/styles/colors"
import { IPayrollExpensesHierarchy, IPayrollExpensesHierarchyEmployee } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import UserCheck from "../../../../assets/icons/user-check"
import * as utils from "../../../helpers/utils"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"

interface IProps {
	payrollExpensesHierarchies: IPayrollExpensesHierarchy[],
	handleSelectHierarchy(selectedHierarchies: IPayrollExpensesHierarchy[]): void
	handleSelectEmployee(selectedEmployees: IPayrollExpensesHierarchyEmployee[], unselectedEmployees: IPayrollExpensesHierarchyEmployee[]): void
	onExpensePayrollFileDownload?(expenseId: string): void
}
interface IState {
	expandRow: number
	selectedHierarchies: IPayrollExpensesHierarchy[]
}

export default class PayrollByHierarchyTable extends React.Component<IProps, IState> {
	private PayrollExpensesByHierarchyEmployeeRow = []
	constructor(props) {
		super(props)
		this.state = {
			expandRow: -1,
			selectedHierarchies: []
		}
		autobind(this)
	}

	handleClickRow(clickedRow) {
		this.setState({
			expandRow: clickedRow === this.state.expandRow ? -1 : clickedRow
		})
	}

	handleSelectPayrollHierarchies(selectedPayrollHierarchies: IPayrollExpensesHierarchy[]) {
		let newSelectedPayrollHierarchies: IPayrollExpensesHierarchy[] = []
		let unSelectedPayrollHierarchies: IPayrollExpensesHierarchy[] = []
		this.props.payrollExpensesHierarchies.forEach(i => {
			const originalSelected = this.state.selectedHierarchies.find(j => j.HierarchyItem.Id === i.HierarchyItem.Id && j.PayrollPayGroupId === i.PayrollPayGroupId)
			const selected = selectedPayrollHierarchies.find(j => j.HierarchyItem.Id === i.HierarchyItem.Id && j.PayrollPayGroupId === i.PayrollPayGroupId)
			originalSelected && !selected &&
				unSelectedPayrollHierarchies.push(i)
			!originalSelected && selected &&
				newSelectedPayrollHierarchies.push(i)
		})

		newSelectedPayrollHierarchies.forEach(i => {
			const rowNumber = this.getPayrollHierarchyRowNumber(i)
			this.PayrollExpensesByHierarchyEmployeeRow[rowNumber].setState({
				selectedEmployees: i.Employees
			})
			this.props.handleSelectEmployee(i.Employees, [])
		})

		unSelectedPayrollHierarchies.forEach(i => {
			const rowNumber = this.getPayrollHierarchyRowNumber(i)
			this.PayrollExpensesByHierarchyEmployeeRow[rowNumber].setState({
				selectedEmployees: []
			})
			this.props.handleSelectEmployee([], i.Employees)
		})

		this.setSelectedHierarchies(selectedPayrollHierarchies)
	}

	getPayrollHierarchyRowNumber(payrollHierarchy: IPayrollExpensesHierarchy) {
		return this.props.payrollExpensesHierarchies.findIndex(i => i.HierarchyItem.Id === payrollHierarchy.HierarchyItem.Id && i.PayrollPayGroupId === payrollHierarchy.PayrollPayGroupId)
	}

	setSelectedHierarchies(selectedHierarchies) {
		this.setState({ selectedHierarchies })
		this.props.handleSelectHierarchy(selectedHierarchies)
	}

	handleSelectEmployee(hierarchyIndex, selectedEmployees, unselectedEmployees) {
		const hierarchy = this.props.payrollExpensesHierarchies[hierarchyIndex]
		let selectedHierarchies = this.state.selectedHierarchies.slice()
		if (unselectedEmployees.length === 0) {
			if (!selectedHierarchies.find(item => item.HierarchyItem.Id === hierarchy.HierarchyItem.Id && item.PayrollPayGroupId && hierarchy.PayrollPayGroupId)) {
				selectedHierarchies.push(hierarchy)
			}
		} else {
			selectedHierarchies = selectedHierarchies.filter(item => item.HierarchyItem.Id !== hierarchy.HierarchyItem.Id || item.PayrollPayGroupId !== hierarchy.PayrollPayGroupId)
		}
		this.setSelectedHierarchies(selectedHierarchies)
		this.props.handleSelectEmployee(selectedEmployees, unselectedEmployees)
	}

	render() {
		return (
			<Table
				items={this.props.payrollExpensesHierarchies}
				selectedItems={this.state.selectedHierarchies}
				handleSelect={this.handleSelectPayrollHierarchies}
				uniqueIdentifier="PayrollStatusDocId"
			>
				<TableHeader>
					<TableRow className="ShortSelectBoxTableHeader">
						<TableHeaderColumn className="TextOverflow" title={strings.Hierarchy_Name} style={styles.hierarchyCol}>{strings.Hierarchy_Name}</TableHeaderColumn>
						{AccountStore.getEnablePayGroupAssignEmployeeLevel() &&
							<TableHeaderColumn className="TextOverflow" title={strings.Pay_Group_Name} style={styles.payGroupCol}>{strings.Pay_Group_Name}</TableHeaderColumn>
						}
						<TableHeaderColumn className="TextOverflow" title={strings.TotalHours} style={styles.currencyCol}>{strings.TotalHours}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Total_Paid} style={styles.currencyCol}>{strings.Total_Paid}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Total_Deducted} style={styles.currencyCol}>{strings.Total_Deducted}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Taxable} style={styles.currencyCol}>{strings.Taxable}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Non_Taxable} style={styles.currencyCol}>{strings.Non_Taxable}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.EMP_Approved} style={styles.iconCol}>{strings.EMP_Approved}</TableHeaderColumn>
						<TableHeaderColumn className="TextOverflow" title={strings.Approved} style={styles.iconCol}>{strings.Approved}</TableHeaderColumn>
						{AccountStore.getEnableEmployeeLock() &&
							<TableHeaderColumn className="TextOverflow" title={strings.EMP_Locked} style={styles.iconCol}>{strings.EMP_Locked}</TableHeaderColumn>
						}
						<TableHeaderColumn className="TextOverflow" title={strings.Locked} style={styles.iconCol}>{strings.Locked}</TableHeaderColumn>
						{AccountStore.getAccrualsTimeoffEnabled() &&
							<TableHeaderColumn className="TextOverflow" title={strings.Closed} style={styles.iconCol}>{strings.Closed}</TableHeaderColumn>
						}
						<TableHeaderColumn className="TextOverflow" title={strings.Exported} style={styles.iconCol}>{strings.Exported}</TableHeaderColumn>
					</TableRow>
				</TableHeader>
				<TableBody deselectOnClickaway={false}>
					{this.props.payrollExpensesHierarchies.map((hierarchyData, index) => {
						const expandState = index === this.state.expandRow
						const selected = this.state.selectedHierarchies.find(item => item.HierarchyItem.Id === hierarchyData.HierarchyItem.Id && item.PayrollPayGroupId === hierarchyData.PayrollPayGroupId) ? true : false
						return (
							<TableRow key={index} className="ShortSelectBoxTableRow" selected={selected}>
								<TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>
									<MaterialTable style={{ backgroundColor: "none" }} onCellClick={() => this.handleClickRow(index)}>
										<TableBody displayRowCheckbox={false}>
											<TableRow data-intercom-target={index === 0 && "menu-Payroll-PayrollExpensesHierarchyTable-openItemDetails"} style={{ cursor: "pointer", height: 48, borderBottom: expandState ? "solid 2px #cccccc" : "none" }}>
												<TableRowColumn style={styles.hierarchyCol}>{hierarchyData.HierarchyItem.Label}</TableRowColumn>
												{AccountStore.getEnablePayGroupAssignEmployeeLevel() &&
													<TableRowColumn style={styles.payGroupCol}>
														{hierarchyData.PayrollPayGroupId ?
															payGroupAndTypeHelper.getPayGroupById(hierarchyData.PayrollPayGroupId).Name :
															strings.Default_PayGroup_of_Payroll_Hierarchy
														}
													</TableRowColumn>
												}
												<TableRowColumn style={styles.currencyCol}>{hierarchyData.ExpensesTotal.TotalTime}</TableRowColumn>
												<TableRowColumn style={styles.currencyCol}>{utils.getCurrencyFormat(hierarchyData.ExpensesTotal.TotalPaid)}</TableRowColumn>
												<TableRowColumn style={styles.currencyCol}>{utils.getCurrencyFormat(hierarchyData.ExpensesTotal.TotalDeducted)}</TableRowColumn>
												<TableRowColumn style={styles.currencyCol}>{utils.getCurrencyFormat(hierarchyData.ExpensesTotal.TotalTaxable)}</TableRowColumn>
												<TableRowColumn style={styles.currencyCol}>{utils.getCurrencyFormat(hierarchyData.ExpensesTotal.TotalNonTaxable)}</TableRowColumn>
												<TableRowColumn style={styles.iconCol}>
													{hierarchyData.TotalEmployees === hierarchyData.TotalEmpApprovedEmployees &&
														<UserCheck
															color={green500}
															width={17.5}
															height={14}
														/>
													}
												</TableRowColumn>
												<TableRowColumn style={styles.iconCol}>
													{hierarchyData.TotalApprovedEmployees === hierarchyData.TotalEmployees &&
														<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
													}
												</TableRowColumn>
												{AccountStore.getEnableEmployeeLock() &&
													<TableRowColumn style={styles.iconCol}>
														{hierarchyData.EmpLockedData && hierarchyData.EmpLockedData.IsLocked &&
															<PayrollByHierarchyTableLockedColumn
																employeeLock
																keyStr={`expense${index}`}
																lockedData={hierarchyData.EmpLockedData}
															/>
														}
													</TableRowColumn>
												}
												<TableRowColumn style={styles.iconCol}>
													{hierarchyData.LockedData &&
														hierarchyData.LockedData.IsLocked && <PayrollByHierarchyTableLockedColumn keyStr={`expense${index}`} lockedData={hierarchyData.LockedData} />}
												</TableRowColumn>
												{AccountStore.getAccrualsTimeoffEnabled() &&
													<TableRowColumn style={styles.iconCol}>
														{hierarchyData.ClosedData &&
															hierarchyData.ClosedData.IsClosed && <PayrollByHierarchyTableClosedColumn keyStr={`expense${index}`} closedData={hierarchyData.ClosedData} />}
													</TableRowColumn>
												}
												<TableRowColumn style={styles.iconCol}>
													{hierarchyData.TotalEmployees === hierarchyData.TotalExportedEmployees &&
														<FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
													}
												</TableRowColumn>
											</TableRow>
											<TableRow style={{ height: expandState ? 48 : 0 }}>
												<TableRowColumn
													colSpan={9 + (AccountStore.getAccrualsTimeoffEnabled() ? 1 : 0) + (AccountStore.getEnableEmployeeLock() ? 1 : 0)}
													style={{ height: expandState ? 48 : 0, padding: expandState ? "50px 0px 50px 0px" : 0 }}
												>
													<div onClick={(e) => e.stopPropagation()}>
														<PayrollExpensesByHierarchyEmployeeRow
															ref={(elem) => this.PayrollExpensesByHierarchyEmployeeRow[index] = elem}
															employees={hierarchyData.Employees}
															expandState={expandState}
															hierarchyIndex={index}
															handleSelectEmployee={this.handleSelectEmployee}
															showExported={false}
															onExpensePayrollFileDownload={this.props.onExpensePayrollFileDownload}
															payrollHierarchyLockedData={hierarchyData.LockedData}
														/>
													</div>
												</TableRowColumn>
											</TableRow>
										</TableBody>
									</MaterialTable>
								</TableRowColumn>
							</TableRow>
						)
					})}
				</TableBody>
			</Table>
		)
	}
}

const styles = {
	hierarchyCol: {
		width: 200,
		paddingLeft: 10,
		paddingRight: 10
	},
	payGroupCol: {
		width: 100,
		paddingLeft: 10,
		paddingRight: 10
	},
	currencyCol: {
		paddingLeft: 10,
		paddingRight: 10,
	},
	iconCol: {
		textAlign: "center",
		paddingLeft: 10,
		paddingRight: 10
	}
}
